import React from "react";
import "./Intro.css";
import Carousel from "components/Carousel";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

export default function Index({ data }) {
  return (
    <section className="robo-intro">
      <div className="container row mx-auto">
        <div className="col-lg-12 img-box">
          <div className="CarouselWrapper container robo-pages">
            <img src={data.intro_hero_img} />
          </div>
        </div>
      </div>

      <div className="row contents">
        <div className="col-lg-6 left-box">
          <div className="text-wrapper">
            <div className="table-cell">
              <h3 className="accent">
                <FormattedMessage id={data.intro_title} />
              </h3>
              <p>
                <FormattedMessage id={data.intro_text} />
              </p>
              <div className="btn accent-button">
                <Link to="/request-a-demo">
                  <FormattedMessage id="book_a_demo" />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 right-box">
          <img src={data.intro_img} alt="goopter promobot" />
        </div>
      </div>
    </section>
  );
}
